import ScrollMagic from 'scrollmagic'
import Flickity from 'flickity'

export default (function() {

  function init(scrollController) {

    const slideshowBlocks = Array.from(document.querySelectorAll('.casestudy-carousel'))

    slideshowBlocks.forEach((slideshowBlock, i) => {

      let scene = new ScrollMagic.Scene({
        triggerElement: slideshowBlock,
        duration: slideshowBlock.offsetHeight,
        triggerHook: 'onEnter',

        // offsetHeight: -200,
      })
      .on('enter', function() {
        let flkty = Flickity.data(slideshowBlock)
        flkty.playPlayer()
      })
      .on('leave', () => {
        let flkty = Flickity.data(slideshowBlock)
        flkty.pausePlayer()
      })
      .reverse(true)
      .addTo(scrollController);
    })
  }

  return {
    init
  }

})();
